"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
const Ability_1 = require("./Ability");
const ClothesDye_1 = require("./ClothesDye");
const definables_1 = require("definables");
const EquipmentPiece_1 = require("./EquipmentPiece");
const HairDye_1 = require("./HairDye");
const Mask_1 = require("./Mask");
const Outfit_1 = require("./Outfit");
class Item extends definables_1.Definable {
    constructor(options) {
        super(options.id);
        this._abilityID = options.definition.abilityID;
        this._characterCustomizeClothesDyeOrder =
            options.definition.characterCustomizeClothesDyeOrder;
        this._characterCustomizeHairDyeOrder =
            options.definition.characterCustomizeHairDyeOrder;
        this._characterCustomizeMaskOrder =
            options.definition.characterCustomizeMaskOrder;
        this._characterCustomizeOutfitOrder =
            options.definition.characterCustomizeOutfitOrder;
        this._clothesDyeID = options.definition.clothesDyeID;
        this._description = options.definition.description;
        this._equipmentPieceID = options.definition.equipmentPieceID;
        this._hairDyeID = options.definition.hairDyeID;
        this._iconImagePath = options.definition.iconImagePath;
        this._maskID = options.definition.maskID;
        this._name = options.definition.name;
        this._outfitID = options.definition.outfitID;
    }
    get ability() {
        if (typeof this._abilityID !== "undefined") {
            return (0, definables_1.getDefinable)(Ability_1.Ability, this._abilityID);
        }
        throw new Error(this.getAccessorErrorMessage("ability"));
    }
    get abilityID() {
        if (typeof this._abilityID !== "undefined") {
            return this._abilityID;
        }
        throw new Error(this.getAccessorErrorMessage("abilityID"));
    }
    get characterCustomizeClothesDyeOrder() {
        return this._characterCustomizeClothesDyeOrder;
    }
    get characterCustomizeHairDyeOrder() {
        return this._characterCustomizeHairDyeOrder;
    }
    get characterCustomizeMaskOrder() {
        return this._characterCustomizeMaskOrder;
    }
    get characterCustomizeOutfitOrder() {
        return this._characterCustomizeOutfitOrder;
    }
    get clothesDye() {
        if (typeof this._clothesDyeID !== "undefined") {
            return (0, definables_1.getDefinable)(ClothesDye_1.ClothesDye, this._clothesDyeID);
        }
        throw new Error(this.getAccessorErrorMessage("clothesDye"));
    }
    get clothesDyeID() {
        if (typeof this._clothesDyeID !== "undefined") {
            return this._clothesDyeID;
        }
        throw new Error(this.getAccessorErrorMessage("clothesDyeID"));
    }
    get description() {
        if (typeof this._description !== "undefined") {
            return this._description;
        }
        throw new Error(this.getAccessorErrorMessage("description"));
    }
    get equipmentPiece() {
        if (typeof this._equipmentPieceID !== "undefined") {
            return (0, definables_1.getDefinable)(EquipmentPiece_1.EquipmentPiece, this._equipmentPieceID);
        }
        throw new Error(this.getAccessorErrorMessage("equipmentPiece"));
    }
    get equipmentPieceID() {
        if (typeof this._equipmentPieceID !== "undefined") {
            return this._equipmentPieceID;
        }
        throw new Error(this.getAccessorErrorMessage("equipmentPieceID"));
    }
    get hairDye() {
        if (typeof this._hairDyeID !== "undefined") {
            return (0, definables_1.getDefinable)(HairDye_1.HairDye, this._hairDyeID);
        }
        throw new Error(this.getAccessorErrorMessage("hairDye"));
    }
    get hairDyeID() {
        if (typeof this._hairDyeID !== "undefined") {
            return this._hairDyeID;
        }
        throw new Error(this.getAccessorErrorMessage("hairDyeID"));
    }
    get iconImagePath() {
        return this._iconImagePath;
    }
    get mask() {
        if (typeof this._maskID !== "undefined") {
            return (0, definables_1.getDefinable)(Mask_1.Mask, this._maskID);
        }
        throw new Error(this.getAccessorErrorMessage("mask"));
    }
    get maskID() {
        if (typeof this._maskID !== "undefined") {
            return this._maskID;
        }
        throw new Error(this.getAccessorErrorMessage("maskID"));
    }
    get name() {
        return this._name;
    }
    get outfit() {
        if (typeof this._outfitID !== "undefined") {
            return (0, definables_1.getDefinable)(Outfit_1.Outfit, this._outfitID);
        }
        throw new Error(this.getAccessorErrorMessage("outfit"));
    }
    get outfitID() {
        if (typeof this._outfitID !== "undefined") {
            return this._outfitID;
        }
        throw new Error(this.getAccessorErrorMessage("outfitID"));
    }
    hasAbility() {
        return typeof this._abilityID !== "undefined";
    }
    hasClothesDye() {
        return typeof this._clothesDyeID !== "undefined";
    }
    hasDescription() {
        return typeof this._description !== "undefined";
    }
    hasEquipmentPiece() {
        return typeof this._equipmentPieceID !== "undefined";
    }
    hasHairDye() {
        return typeof this._hairDyeID !== "undefined";
    }
    hasMask() {
        return typeof this._maskID !== "undefined";
    }
    hasOutfit() {
        return typeof this._outfitID !== "undefined";
    }
}
exports.Item = Item;
